/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import {
  PolymerElement,
  html
} from "@polymer/polymer/polymer-element.js";
import {
  OEFieldMixin
} from "oe-mixins/oe-field-mixin.js";
class newPin extends PolymerElement {
  static get properties() {
    return {
      value: {
        type: String,
        notify: true
      },
      errorMessage: {
        type: String,
        notify: true
      },
      cardpin: {
        type: Number,
        notify: true
      },
      maxlength: {
        type: Number,
        notify: true
      },
      required: {
        type: Boolean,
        notify: true
      },
      label: {
        type: String,
        notify: true,
        observer: '_label'
      },
      validationErrorMessage: {
        type: String,
        notify: true
      },
      allowedPattern: {
        type: String,
        notify: true
      },
      /** True if the content of the password field is visible */
      visible: {
        type: Boolean,
        value: false
      }
    };
  }

  static get template() {
    return html `
        <style include="app-styles">
                #new{
          padding-right: 16px;
        }
        #confirm{
          padding-left : 16px;
        }
        paper-input{
          --paper-input-container: {
            position: relative;
            top: 0px;
          }
          }
        .visibility-icon {
          color: var(--disabled-text-color);
          /** Bottom aligns visibility button with input box */
          height: 32px;
          width: 32px;
          padding: 0 4px;
          margin-top: -55px;
          margin-left: 90% !important;
          background : white;
        }
        /** CSS modified for visibility button with input box for Firefox Browser */
        @-moz-document url-prefix() {
          .visibility-icon {
            margin-top: -70px;
          }
        }
        /** CSS modified for visibility button with input box for Edge Browser */
        @supports (-ms-ime-align: auto){
          .visibility-icon {
            margin-top: -58px;
            margin-left: 92% !important;
            top:-35%;
            background : white;
          }
        }
        </style>
        <oe-ajax id="prpmCardPinLen" content-type="application/json" handle-as="json" method="get" on-response="prpmCardSuccess" on-error="cardpinlengthfixed"></oe-ajax> 
        <div class="full-width">
          <paper-input id="newPin" class="full width" type="[[_getType(visible)]]" value="{{value}}" label="[[label]]" maxlength="[[maxlength]]" required="[[required]]" auto-validate oncopy="return false" onpaste="return false" allowed-pattern="{{allowedPattern}}" char-counter on-blur="_checkLength">
          </paper-input>
        </div>
        <paper-icon-button id="eyeIcon" slot="suffix" icon="[[_getIcon(visible)]]" on-tap="_toggleVisible" class="visibility-icon" alt="[[alt]]" title="click to show password"></paper-icon-button>
    `;
  }
  constructor() {
    super();
  }

  ready() {
    super.ready();
    this.$.prpmCardPinLen.url = "/api/propertyreferences?filter[where][appId]=BWY&filter[where][propertyName]=CARD_PIN_LENGTH";
//    this.$.prpmCardPinLen.generateRequest();
  }

  prpmCardSuccess(event) {
    this.maxlength = event.detail.response[0].propertyValue;
  }
  cardpinlengthfixed(event) {
    this.cardpin = 4;
  }
  _label() {
    this.label = getLabel(this.label);
  }
  _validate() {
    var isValid = true;
    // this.setValidity(true, undefined);
    if (_.isUndefined(this.value) || _.isEmpty(this.value)) {
      this.$.newPin.invalid = true;
      this.$.newPin.errorMessage = getLabel(this.errorMessage);
      // this.setValidity(false, 'wrongValue');
      isValid = false;
    }
    else if (this.value.length != this.maxlength) {
      this.$.newPin.invalid = true;
      this.$.newPin.errorMessage = getLabel("m_pinLengthInvalid"); // this.setValidity(false, 'wrongValue');

      isValid = false;
    }

    return isValid;
  }
  validate() {
    return this.$.input.validate();
  }
  _getIcon(visible) {
    if (visible) {
      this.$.eyeIcon.title = "Press enter to hide the password";
    }
    else {
      this.$.eyeIcon.title = "Press enter to view the password";
    }
    return visible ? 'icons:visibility' : 'icons:visibility-off';
  }
  _getType(visible) {
    return visible ? '' : 'password';
  }
  _toggleVisible() {
    this.visible = !this.visible;
  }

  _checkLength() {
    this._validate();
  }

}
customElements.define('new-pin', OEFieldMixin(newPin));